/* eslint-disable jsx-a11y/anchor-has-content,jsx-a11y/href-no-hash */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { changeFieldQuizAddAsk } from 'mt-react-common/modules/tasks/reducers/dynamic/taskFrom/actions';
import { selectFieldQuiz } from 'mt-react-common/modules/tasks/reducers/dynamic/taskFrom/selectors';
import { connect } from 'react-redux';
import { t } from 'utils/translates';

import PopUpLink from 'components/Common/GlobalPopUps/PopUpLink';

import QuizAscInput from './QuizAscInput';

// eslint-disable-next-line react/prefer-stateless-function
class CheckTypeQuiz extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="tab-pane" id="auto-check">
          <div className="alert alert-warning alert-dismissable">
            <a
              aria-hidden="true"
              className="close close-black"
              data-dismiss="alert"
              href=""
            />
            <h4>
              <i className="fa fa-exclamation-triangle" /> {t('Подсказка')}
            </h4>
            <p>
              {t(
                '<strong>Ответ на вопрос</strong> должен быть однозначным и точным (можно указать несколько вариантов написания одного и того же ответа) <br /> <strong> В самом вопросе или описании задания должно быть </strong> указано где и как найти ответ, и в каком виде в точности его нужно написать.'
              )}
            </p>
            <p>
              <PopUpLink
                style={{ color: '#2b96f1' }}
                hashName="infoMaterials"
                hashParams={{ id: 'recommendations_by_auto_task' }}
              >
                {t('Рекомендации по заданиям с автоматической оплатой')}
              </PopUpLink>
            </p>
          </div>
          {this.props.fieldQuiz.value.map((value, keyAsk) => (
            <QuizAscInput
              key={`QuizAscInput${keyAsk + 1}`}
              reducerName={this.props.reducerName}
              keyAsk={keyAsk}
            />
          ))}
          <div className="form-group m-b-0">
            <button
              className="btn btn-default"
              type="button"
              onClick={() => this.props.changeFieldQuizAddAsk()}
            >
              <i className="fa fa-plus" /> {t('Добавить вопрос')}
            </button>
            <small className="help-block m-b-0">
              {t(
                'Чем больше вопросов-ответов и чем чаще Вы их меняете, тем лучше (безопасней)'
              )}
            </small>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

CheckTypeQuiz.propTypes = {
  // IN
  reducerName: PropTypes.string.isRequired,
  // CONNECT
  fieldQuiz: PropTypes.shape({
    value: PropTypes.any.isRequired,
    errors: PropTypes.array.isRequired
  }).isRequired,
  changeFieldQuizAddAsk: PropTypes.func.isRequired
};

const mapStateToProps = (state, props) => ({
  fieldQuiz: selectFieldQuiz(state, props.reducerName)
});

const mapDispatchToProps = (dispatch, props) => ({
  changeFieldQuizAddAsk: () =>
    dispatch(changeFieldQuizAddAsk(props.reducerName))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CheckTypeQuiz);



// WEBPACK FOOTER //
// ./src/components/Tasks/TaskFrom/CheckTaskInputs/CheckTypeQuiz/CheckTypeQuiz.js